import { SvgIcon } from "@mui/material";

export const Diamond = (props: any) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 21">
      <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17.818 0H6.18203L0 6.32345L12 20.1324L24 6.32345L17.818 0ZM15.2608 7.05465L12 16.837L8.73918 7.05465H15.2608ZM9.16992 5.6484L12 1.87499L14.83 5.6484H9.16992ZM13.4062 1.40624H16.6409L15.8877 4.71489L13.4062 1.40624ZM8.11223 4.71489L7.3591 1.40624H10.5937L8.11223 4.71489ZM6.88252 5.6484H2.62658L6.07871 2.11728L6.88252 5.6484ZM7.25691 7.05465L10.218 15.9379L2.49842 7.05465H7.25691ZM16.7431 7.05465H21.5016L13.782 15.9379L16.7431 7.05465ZM17.1175 5.6484L17.9213 2.11728L21.3734 5.6484H17.1175Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};
